import React from 'react';
import { Link } from 'react-router-dom';

const ForbiddenPage = () => {
  return (
    <div className="error-page">
      <h1>403 Forbidden</h1>
      <p>Access to this resource is forbidden. You do not have permission to view this page.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default ForbiddenPage;
